import React from "react";
import { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import {
  BiChevronLeft,
  BiChevronRight,
  BiRadioCircleMarked,
} from "react-icons/bi";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";
import { AiOutlineCopyright } from "react-icons/ai";
import personIcon from "../assets/images icons/2x/baseline_people_alt_black_24dp.png";

import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext,
} from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
import { white } from "picocolors";

import Header from "../components/header";
import Card from "../components/cards";
import HowItWorks from "../components/howItWorks";
import Footer from "../components/Footer";

function App() {
  const navButtons = [
    {
      title: "Location",
      active: false,
      action: () => {
        console.log("wroks");
      },
    },
    {
      title: "Type",
      active: false,
      action: () => {
        console.log("wroks");
      },
    },
    {
      title: "Approach",
      active: true,
      action: () => {
        console.log("wroks");
      },
    },
    {
      title: "Language",
      active: false,
      action: () => {
        console.log("wroks");
      },
    },
    {
      title: "Gender",
      active: false,
      action: () => {
        console.log("wroks");
      },
    },
    {
      title: "Price",
      active: false,
      action: () => {
        console.log("wroks");
      },
    },
    {
      title: "Reset",
      active: false,
      action: () => {
        console.log("wroks");
      },
    },
    {
      title: "Open Maps",
      active: false,
      action: () => {
        console.log("wroks");
      },
    },
  ];

  return (
    <div className="w-full bg-themebg">
      <Header />

      <HowItWorks />

      {/* Navbar Start  */}
      <div className="h-auto mx-auto mt-16 w-5/6 flex flex-rows sticky top-0 bg-themebg p-4">
        <div className="w-3/4 flex">
          <img className="h-10" src={personIcon} alt="" />
          <p className="text-2xl">Lorem</p>
          {navButtons.map((item) => (
            <button
              className={
                item.active
                  ? "py-0 px-2.5 ml-1 rounded-3xl border border-green bg-red text-white text-sm"
                  : "py-0 px-2.5 ml-1 rounded-3xl border border-green bg-green text-white text-sm"
              }
            >
              {item.title}
            </button>
          ))}
        </div>
        <div className="w-1/4">asd</div>
      </div>
      {/* Navbar End  */}

      {/* Cards start */}
      <div className="h-auto mx-auto mt-8 w-5/6 flex flex-row">
        <div className="w-3/4">
          {[false, false, true, true].map((item) => (
            <Card item={item} />
          ))}
          <div className="flex flex-wrap pt-2 pb-2 justify-between w-1/3 ml-auto -mt-5">
            <button className="py-1 w-8 text-center bg-gray-200 mt-2 ">
              <BiChevronLeft size={20} className="m-auto" />
            </button>
            <button className="py-1 w-8 text-center bg-gray-200 mt-2 ">
              1
            </button>
            <button className="py-1 w-8 text-center bg-gray-200 mt-2 ">
              2
            </button>
            <button className="py-1 w-8 text-center bg-gray-200 mt-2 ">
              3
            </button>
            <button className="py-1 w-8 text-center bg-gray-200 mt-2 ">
              4
            </button>
            <button className="py-1 w-8 text-center bg-gray-200 mt-2 ">
              5
            </button>
            <button className="py-1 w-8 text-center bg-gray-200 mt-2 ">
              6
            </button>
            <button className="py-1 w-8 text-center bg-gray-200 mt-2 ">
              <BiChevronRight size={20} className="m-auto" />
            </button>
          </div>
          <div className="w-98 bg-green rounded-lg h-38 py-4 px-8 flex flex-row justify-between items-center my-16 ml-auto">
            <img
              src={require("../assets/index/d_banner.png")}
              alt=""
              className="h-32 "
            />
            <div className="right w-3/4">
              <p className="text-white text-xl font-gilroy ">
                Unsure about which consultant is right for you?
              </p>
              <p className="text-white text-md leading-5 ">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Ratione
                officia deserunt excepturi in reprehenderit
              </p>
              <button className="py-0.5 px-10 mr-1.5 rounded-3xl border border-green bg-white mt-2 text-green font-gilroy mt-5">
                Send Us a Message
              </button>
            </div>
          </div>
          <div className="w-98 rounded-lg py-4 pl-8 flex flex-row justify-between items-center my-16 ml-auto">
            <div className="right w-2/4 pr-8">
              <p className="text-lg font-gilroy tracking-wide">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit
              </p>
              <p className="text-md leading-5 pr-1">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras
                dui mi, dapibus et ipsum vitae, sollicitudin finibus urna.
                Quisque quis neque semper, finibus sapien vel, placerat arcu.
              </p>
            </div>
            <img
              src={require("../assets/index/doctor.png")}
              alt=""
              className="h-60 rounded-lg w-2/4"
            />
          </div>
          <div className="w-full text-center">
            <p className="text-4xl font-gilroy tracking-wide">FAQ</p>
            <div className="w-full h-auto py-10">
              <div className="w-full border rounded-xl border-t-0 mb-4 border-gray shadow-md">
                <div className="py-4 bg-green text-white px-5 flex flex-row justify-between items-center rounded-xl">
                  <p className="text-xl tracking-wide">Payment</p>
                  <BsChevronDown size={30} className="cursor-pointer" />
                </div>
              </div>
              <div className="w-full border rounded-xl border-t-0 mb-4 border-gray shadow-md">
                <div className="py-4 bg-green text-white px-5 flex flex-row justify-between items-center rounded-xl">
                  <p className="text-xl tracking-wide">Payment</p>
                  <BsChevronUp size={30} className="cursor-pointer" />
                </div>
                <div className="h-auto w-full text-left px-5 py-3">
                  Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                  Possimus officia voluptas hic suscipit ratione magnam dicta
                  sit velit iure ea aperiam fuga ullam numquam laborum
                  distinctio quis, consectetur veritatis veniam?
                </div>
              </div>
              <div className="w-full border rounded-xl border-t-0 mb-4 border-gray shadow-md">
                <div className="py-4 bg-green text-white px-5 flex flex-row justify-between items-center rounded-xl">
                  <p className="text-xl tracking-wide">Payment</p>
                  <BsChevronDown size={30} className="cursor-pointer" />
                </div>
              </div>
              <div className="w-full border rounded-xl border-t-0 mb-4 border-gray shadow-md">
                <div className="py-4 bg-green text-white px-5 flex flex-row justify-between items-center rounded-xl">
                  <p className="text-xl tracking-wide">Payment</p>
                  <BsChevronDown size={30} className="cursor-pointer" />
                </div>
              </div>
            </div>
          </div>
          <div className="w-full text-center">
            <p className="text-4xl font-gilroy tracking-wide">Newsletter</p>
            <div className="w-4/5 flex flex-row justify-between mt-5 mb-10 items-center mx-auto">
              <input
                type="text"
                placeholder="Enter Your Email"
                className=" w-7/12 border border-gray rounded-full px-5 py-2"
              />
              <button className=" rounded-3xl border border-green bg-green text-white px-5 py-2 w-2/5">
                Subscribe
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Cards start */}
      <Footer />
    </div>
  );
}

export default App;
